"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ArrowDownCircleSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var ArrowDownCircleSVG = function ArrowDownCircleSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm7.69 15.69l-6.89 7a1.13 1.13 0 01-.8.31 1.09 1.09 0 01-.8-.31l-6.89-7a1.07 1.07 0 010-1.5 1 1 0 011.48 0L15 21.5V8a1 1 0 112 0v13.5l5.22-5.31a1 1 0 011.48 0 1.07 1.07 0 01-.01 1.5z"
  }));
};
exports.ArrowDownCircleSVG = ArrowDownCircleSVG;
ArrowDownCircleSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ArrowDownCircleSVG);
exports.default = _default;